import Immutable from 'immutable';
import React from 'react';

import Button from 'sharedreact/components/Button';
import SearchField from 'sharedreact/components/SearchField';
import Tab from 'sharedreact/components/Tab';
import Toolbar from 'sharedreact/components/Toolbar';
import ToolbarGroup from 'sharedreact/components/ToolbarGroup';
import ToolbarTitle from 'sharedreact/components/ToolbarTitle';
import SortOrder from 'sharedreact/data/SortOrder';
import { RangeType } from 'sharedreact/stores/generic/Type';
import { translate } from 'sharedreact/utils/LanguageSupport';

import AuditRecord from 'sharedreact/data/AuditRecord';
import AuditTable from 'workspaces/launcher/components/admin/AuditTable';

type Props = {
  index: number,
  activeTab: number,
  language: string,
  auditRecords: Immutable.List<AuditRecord | null>,
  sortOrder: SortOrder,
  filter: string,
  filterKeywords: string[],
  isFetching: boolean,

  onLoad: () => void,
  setFilter: (searchString: string) => void,
  setVisibleRange: (visibleRange: RangeType) => void,
  onSortOrderChange: (sortOrder: SortOrder) => void,
  onRefresh: () => void
};

class AuditTab extends React.Component<Props> {
  override componentDidMount (): void {
    if (this.props.activeTab === this.props.index) {
      this.props.onLoad();
    }
  }

  override componentDidUpdate (prevProps: Readonly<Props>): void {
    if (prevProps.activeTab !== this.props.activeTab && this.props.activeTab === this.props.index) {
      this.props.onLoad();
    }
  }

  override render (): React.ReactNode {
    const {
      language, index, activeTab,
      auditRecords,
      sortOrder, onSortOrderChange,
      filter, filterKeywords, setFilter,
      setVisibleRange,
      onRefresh } = this.props;

    return (
      <Tab index={index} activeIndex={activeTab}>
        <Toolbar>
          <ToolbarGroup>
            <ToolbarTitle title={translate('launcher.admin.audit.title')} />
          </ToolbarGroup>
          <ToolbarGroup align='right'>
            <Button id='ae_button_about_refesh'
              icon='bi bi-arrow-repeat'
              onClick={onRefresh}
            />
          </ToolbarGroup>
          <ToolbarGroup align='right'>
            <SearchField id='ae_search_files'
              alignRight
              onSearch={setFilter}
              value={filter}
              keywords={filterKeywords}
              highlight={filter !== ''}
            />
          </ToolbarGroup>
        </Toolbar>
        <div className='webappslauncher-scroll-container'>
          <div className='webappslauncher-stretch-container'>
            <AuditTable
              language={language}
              auditRecords={auditRecords}
              sortOrder={sortOrder}
              setVisibleRange={setVisibleRange}
              onSortOrderChange={onSortOrderChange}
              emptyTableText='launcher.admin.audit.noauditrecords'
            />
          </div>
        </div>
      </Tab>
    );
  }
}

export default AuditTab;
